// Align the actual roof-to-foot height, independently of each illustration's crop.
(()=>{
 const grid=document.querySelector('.motorized-installation-grid');if(!grid)return;
 const bounds=[{w:452,top:216,bottom:490},{w:388,top:221,bottom:483},{w:664,top:225,bottom:477},{w:668,top:222,bottom:480}];
 const visuals=[...grid.querySelectorAll('.motorized-installation-visual')];
 function layout(){
  const height=Math.min(180,...visuals.map((el,i)=>(el.clientWidth-8)*(bounds[i].bottom-bounds[i].top)/bounds[i].w*1.16));
  visuals.forEach((el,i)=>{const box=bounds[i],scaleY=height/(box.bottom-box.top),scaleX=scaleY/1.16,svg=el.querySelector('svg');
   svg.setAttribute('preserveAspectRatio','none');
   Object.assign(svg.style,{position:'absolute',width:box.w*scaleX+'px',height:420*scaleY+'px',left:'50%',top:(el.clientHeight-38-(box.bottom-130)*scaleY)+'px',transform:'translateX(-50%)'});
  });
 }
 new ResizeObserver(layout).observe(grid);layout();
})();
